import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import PDFViewer from "./PlanComponents/PDFViewer";
import CommentLetter from "./PlanComponents/CommentLetter";
import CommentsRepository from "./PlanComponents/CommentsRepository";
import SupportPDFViewer from "./PlanComponents/SupportPDFViewer";
import {
  saveCommentLetter,
  getCommentRepoDisciplines,
  getInitialComments,
  getMoreComments,
  searchComments,
  getMoreCommentsWithSearch,
} from "@safecv/actions/postActions";

import "./PlanViewer.css";

function PlanViewer(props) {
  //props received from parent component can be used
  const [disciplines, setDisciplines] = useState(null);
  const [activeDiscipline, setActiveDiscipline] = useState(null);
  const [activeDisciplineId, setActiveDisciplineId] = useState(null);
  const [currentData, setcurrentData] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const {
    jobId,
    isSidebarOpen,
    isPdfSelected,
    isDocumentSelected,
    isCommentRepoSelected,
    isReconciliationSidebarOpen,
    setIsPdfSelected,
    setIsCommentRepoSelected,
    planStatus,
    commentLetterData,
    initialComments,
    isSupportDocSelected,
    commentLetterId,
  } = props;

  useEffect(() => {
    props.getCommentRepoDisciplines(jobId);
  }, []);

  useEffect(() => {
    if (props.disciplines !== undefined) {
      let currentDisciplines = [{id:0,name:"All"},...props.disciplines]
      setDisciplines(currentDisciplines);
      setActiveDiscipline(currentDisciplines[0].id);
    }
  }, [props.disciplines]);

  useEffect(() => {
    let requestObj;
    let allActive = (activeDiscipline==0)?true:false;
    if (activeDiscipline !== null && activeDiscipline !== undefined ) {
         requestObj = {
          allChipFlag: allActive,
          allCommentSize: allActive?0:3,
          disciplineId: activeDiscipline,
          myCommentsSize: allActive?10:3,
          topCommentsSize: allActive?10:3,  
        }
        props.getInitialComments(requestObj); 
      }
  }, [activeDiscipline]);

  const debounceValue = useRef(
    _.debounce((req) => {
      props.searchComments(req);
    }, 300)
  );

  const debounceValueWithoutSearch = useRef(
    _.debounce((req) => {
      props.getInitialComments(req);
    }, 300)
  );

  useEffect(() => {
    let requestObj;
    let allActive = (activeDiscipline==0)?true:false;
    if (searchText !== null && searchText.trim() !== "") {
      requestObj = {
        allChipFlag:allActive,
        allCommentSize: allActive?0:3,
        disciplineId: activeDiscipline,
        myCommentsSize: allActive?10:3,
        topCommentsSize: allActive?10:3,
        searchText: encodeURIComponent(searchText),
      };
      debounceValue.current(requestObj);
    } else {
      if (activeDiscipline !== null) {
        requestObj = {
          allChipFlag:allActive,
          allCommentSize: allActive?0:3,
          disciplineId: activeDiscipline,
          myCommentsSize: allActive?10:3,
          topCommentsSize: allActive?10:3,
        };
        debounceValueWithoutSearch.current(requestObj);
      }
    }
  }, [searchText]);

  useEffect(() => {
    if (currentData !== null) {
      let requestBody = {
        id: commentLetterId,
        jobId: jobId,
        commentLetter: currentData,
      };
      props.saveCommentLetter(requestBody);
    }
  }, [currentData]);

  const [showCommentRepo, setShowCommentRepo] = useState(false);

  const setCommentRepo = (value) => {
    setShowCommentRepo(value);
    setIsCommentRepoSelected(value);
    setIsPdfSelected(false);
  };

  useEffect(() => {
    setShowCommentRepo(isCommentRepoSelected);
  }, [isCommentRepoSelected]);

  const showMoreComments = (commentsSize, disciplineId, lastId, section) => {
    if (searchText === null || searchText === "") {
      let showMoreReq = {
        allChipFlag: (activeDiscipline==0)?true:false,
        commentsSize: commentsSize,
        disciplineId: disciplineId,
        id: lastId,
        section: section,
      };
      props.getMoreComments(showMoreReq);
    } else {
      let showMoreReq = {
        allChipFlag: (activeDiscipline==0)?true:false,
        commentsSize: commentsSize,
        disciplineId: disciplineId,
        id: lastId,
        section: section,
        searchText: searchText,
      };
      props.getMoreCommentsWithSearch(showMoreReq);
    }
  };

  // Basically a document renderer. It renders plan and also the comment letter.
  // Each of them becomes a component and PlanViewer will be the container that decides what to render.

  return (
    // to maintain the sidebar width
    <div
      className={`landing-plan-container ${
        isSidebarOpen || isReconciliationSidebarOpen
          ? ""
          : "landing-plan-container-full"
      }`}
    >
      {/* to maintain the split screen and pdf container size */}
      <div
        className={
          (isDocumentSelected && isPdfSelected) ||
          (isDocumentSelected && showCommentRepo && !isPdfSelected)
            ? "landing-plan-split"
            : "landing-plan-full"
        }
      >
        {!isSupportDocSelected && <PDFViewer {...props} />}
        {isSupportDocSelected && <SupportPDFViewer {...props} />}
        {/* {isDocumentSelected && <CommentLetter jobId={jobId} />} */}
        {isCommentRepoSelected && initialComments && (
          <CommentsRepository
            setCommentRepo={setCommentRepo}
            disciplines={disciplines}
            activeDiscipline={activeDiscipline}
            setActiveDiscipline={setActiveDiscipline}
            setActiveDisciplineId={setActiveDisciplineId}
            activeDisciplineId={activeDisciplineId}
            showMoreComments={showMoreComments}
            setSearchText={setSearchText}
            searchText={searchText}
          />
        )}
        {commentLetterData && (
          <CommentLetter
            jobId={jobId}
            isDocumentSelected={isDocumentSelected}
            data={commentLetterData}
            setcurrentData={setcurrentData}
            setCommentRepo={setCommentRepo}
            planStatus={planStatus}
          />
        )}
      </div>
    </div>
  );
}

const mapStatetoProps = (state) => ({
  commentLetterLoading: state.verification.commentLetterLoading,
  disciplines: state.verification.disciplines.data,
  initialComments: state.verification.initialComments,
  commentLetterData: state.verification.commentLetter,
});

const mapDispatchtoProps = (dispatch) => {
  return {
    saveCommentLetter: (data) => {
      dispatch(saveCommentLetter(data));
    },
    getCommentRepoDisciplines: (jobId) => {
      dispatch(getCommentRepoDisciplines(jobId));
    },
    getInitialComments: (data) => {
      dispatch(getInitialComments(data));
    },
    getMoreComments: (data) => {
      dispatch(getMoreComments(data));
    },
    searchComments: (data) => {
      dispatch(searchComments(data));
    },
    getMoreCommentsWithSearch: (data) => {
      dispatch(getMoreCommentsWithSearch(data));
    },
  };
};

export default connect(mapStatetoProps, mapDispatchtoProps)(PlanViewer);
